export function isDefined(obj: any): boolean {
    return obj !== undefined && obj !== null;
}

export const delay = (time: number) => new Promise(res => setTimeout(res, time));

export function isString(obj: any): obj is string {
    return typeof obj === 'string' || obj instanceof String;
}